// import zdjęć
import zdj0 from '../assets/kwiaty2/0.jpg'
import zdj1 from '../assets/kwiaty2/1.jpg'
import zdj2 from '../assets/kwiaty2/2.jpg'
import zdj3 from '../assets/kwiaty2/3.jpg'
import zdj4 from '../assets/kwiaty2/4.jpg'
import zdj5 from '../assets/kwiaty2/5.jpg'
import zdj6 from '../assets/kwiaty2/6.jpg'
import zdj7 from '../assets/kwiaty2/7.jpg'
import zdj8 from '../assets/kwiaty2/8.jpg'
import zdj9 from '../assets/kwiaty2/9.jpg'
import zdj10 from '../assets/kwiaty2/10.jpg'
import zdj11 from '../assets/kwiaty2/11.jpg'
import zdj12 from '../assets/kwiaty2/12.jpg'
import zdj13 from '../assets/kwiaty2/13.jpg'
import zdj14 from '../assets/kwiaty2/14.jpg'
import zdj15 from '../assets/kwiaty2/15.jpg'
import zdj16 from '../assets/kwiaty2/16.jpg'
import zdj17 from '../assets/kwiaty2/17.jpg'
import zdj18 from '../assets/kwiaty2/18.jpg'
import zdj19 from '../assets/kwiaty2/19.jpg'
import zdj20 from '../assets/kwiaty2/20.jpg'
import zdj21 from '../assets/kwiaty2/21.jpg'
import zdj22 from '../assets/kwiaty2/22.jpg'
import zdj23 from '../assets/kwiaty2/23.jpg'
import zdj24 from '../assets/kwiaty2/24.jpg'
import zdj25 from '../assets/kwiaty2/25.jpg'
import zdj26 from '../assets/kwiaty2/26.jpg'
import zdj27 from '../assets/kwiaty2/27.jpg'
import zdj28 from '../assets/kwiaty2/28.jpg'
import zdj29 from '../assets/kwiaty2/29.jpg'


//let pictures = [];

/*
let numberOfPictures = 30;
// nie działa zmiana nazwy zmiennej zdgodnie z indeksem
for (let index = 0; index < numberOfPictures; index++) {
    pictures.push({id:index, path:[`zdj${index}`]});   
}

*/

// tablica obiektów z informacjami o zdjęciu
let pictures = [
    // id is used in JSX as a key
    {id:0, path:zdj0, name:"kwiatek0"},
    {id:1, path:zdj1, name:"kwiatek1"},
    {id:2, path:zdj2, name:"kwiatek2"},
    {id:3, path:zdj3 ,name:"kwiatek3"},
    {id:4, path:zdj4, name:"kwiatek4"},
    {id:5, path:zdj5, name:"kwiatek5"},
    {id:6, path:zdj6, name:"kwiatek6"},
    {id:7, path:zdj7, name:"kwiatek7"},
    {id:8, path:zdj8, name:"kwiatek8"},
    {id:9, path:zdj9, name:"kwiatek9"},
    {id:10, path:zdj10, name:"kwiatek10"},
    {id:11, path:zdj11, name:"kwiatek11"},
    {id:12, path:zdj12, name:"kwiatek12"},
    {id:13, path:zdj13, name:"kwiatek13"},
    {id:14, path:zdj14, name:"kwiatek14"},
    {id:15, path:zdj15, name:"kwiatek15"},
    {id:16, path:zdj16, name:"kwiatek16"},
    {id:17, path:zdj17, name:"kwiatek17"},
    {id:18, path:zdj18, name:"kwiatek18"},
    {id:19, path:zdj19, name:"kwiatek19"},
    {id:20, path:zdj20, name:"kwiatek20"},
    {id:21, path:zdj21, name:"kwiatek21"},
    {id:22, path:zdj22, name:"kwiatek22"},
    {id:23, path:zdj23, name:"kwiatek23"},
    {id:24, path:zdj24, name:"kwiatek24"},
    {id:25, path:zdj25, name:"kwiatek25"},
    {id:26, path:zdj26, name:"kwiatek26"},
    {id:27, path:zdj27, name:"kwiatek27"},
    {id:28, path:zdj28, name:"kwiatek28"},
    {id:29, path:zdj29, name:"kwiatek29"}   
]
export default pictures; 
  
  